import { Image } from 'expo-image';
import { X } from 'lucide-react-native';
import { twJoin } from 'tailwind-merge';

import { HStack } from './ui/hstack';
import { Icon } from './ui/icon';
import { Pressable } from './ui/pressable';
import { VStack } from './ui/vstack';

import { half_logo } from '@/assets/images';
import { Text } from '@/components/ui/text';

type Props = {
  children: React.ReactNode;
  verticalAligned?: boolean;
  onBack?: () => void;
  rightContent?: React.ReactNode; // optional right-side slot for web
};

export default function UnauthenticatedLayout({
  children,
  onBack,
  verticalAligned = true,
  rightContent,
}: Props) {
  return (
    <HStack className="h-screen w-full">
      <VStack className={twJoin('flex-1', verticalAligned ? 'justify-center' : 'justify-start')}>
        <VStack className="w-full px-5">
          <VStack className="mx-auto w-full web:max-w-md">{children}</VStack>
        </VStack>

        {onBack ? (
          <Pressable
            onPress={onBack}
            className="absolute right-9 top-9 z-10 flex-row items-center gap-x-2">
            <Text size="sm" className="text-primary-500">
              Close
            </Text>

            <Icon as={X} size="lg" className="text-primary-500" />
          </Pressable>
        ) : null}
      </VStack>

      <VStack
        className={twJoin(
          'hidden flex-1 justify-center bg-primary-500 px-4 md:flex',
          rightContent ? 'items-center' : 'items-end'
        )}>
        {rightContent ? (
          rightContent
        ) : (
          <Image
            alt="hal-logo"
            source={half_logo}
            contentFit="contain"
            style={{
              maxWidth: '100%',
              height: '70%',
              aspectRatio: 0.87,
            }}
          />
        )}
      </VStack>
    </HStack>
  );
}
